/* this file is transformed by vux-loader */
/* eslint-disable */
import _typeof from "G:/SVN/\u5B9A\u5236\u9879\u76EE/\u534E\u7535\u5F00\u5173/7_\u6E90\u4EE3\u7801/front/smy-vux-cli3-h5-huadian/node_modules/@babel/runtime/helpers/esm/typeof";
import _classCallCheck from "G:/SVN/\u5B9A\u5236\u9879\u76EE/\u534E\u7535\u5F00\u5173/7_\u6E90\u4EE3\u7801/front/smy-vux-cli3-h5-huadian/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "G:/SVN/\u5B9A\u5236\u9879\u76EE/\u534E\u7535\u5F00\u5173/7_\u6E90\u4EE3\u7801/front/smy-vux-cli3-h5-huadian/node_modules/@babel/runtime/helpers/esm/createClass";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.object.keys.js";
import axios from 'axios'; // import router from '@/router'

import store from '@/store';
var CancelToken = axios.CancelToken;
var source = CancelToken.source();
var timer;

var LRUCache = /*#__PURE__*/function () {
  function LRUCache() {
    var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;

    _classCallCheck(this, LRUCache);

    this.map = new Map();
    this.cache = [];
    this.max = n;
  }

  _createClass(LRUCache, [{
    key: "set",
    value: function set(key, value) {
      if (this.has(key)) {
        this.map.set(key, value);
      } else {
        if (this.cache.length >= this.max) {
          var first = this.cache.shift();
          this.map.delete(first);
        }

        this.cache.push(key);
        this.map.set(key, value);
      }
    }
  }, {
    key: "get",
    value: function get(key) {
      return this.map.get(key);
    }
  }, {
    key: "has",
    value: function has(key) {
      return this.map.has(key);
    }
  }]);

  return LRUCache;
}();

var nameMap = new LRUCache(20);

function cancelIfshortTime(config, time) {
  var res = false; // 设置key

  var salt = '';

  if (_typeof(config.data) === 'object') {
    salt += JSON.stringify(config.data);
  } else {
    salt += config.data || '';
  }

  if (_typeof(config.params) === 'object') {
    salt += JSON.stringify(config.params);
  } else {
    salt += config.params || '';
  }

  var key = config.url + salt;

  if (nameMap.has(key)) {
    res = time - nameMap.get(key) < 1000; // 小于1s的请求
  } // 更新时间


  nameMap.set(key, time);
  return res;
}

function request(config) {
  if (config.method !== 'get') {
    // 取消请求判定
    var res = cancelIfshortTime(config, new Date().getTime());

    if (res) {
      config.cancelToken = source.token;
      source.cancel({
        res: 'cancel',
        message: config.url
      });
    }

    var user = store.state.globalStore.user;

    if (user && Object.keys(user).length > 0) {
      var ctoken = user.csrfToken;

      if (config.method === 'post' || config.method === 'put' || config.method === 'patch') {
        // 判断参数是否经过stringify转换
        if (_typeof(config.data) === 'object') {
          config.data.ctoken = ctoken;
        } else {
          if (config.data) {
            config.data += '&ctoken=' + ctoken;
          } else {
            config.data = 'ctoken=' + ctoken;
          }
        }
      } else if (config.method === 'delete') {
        if (config.url.indexOf('?') === -1) {
          config.url += '?ctoken=' + ctoken;
        } else {
          config.url += '&ctoken=' + ctoken;
        }
      }
    }
  }

  return config;
}

function responce(res) {
  try {
    if (res) {
      switch (res.status) {
        case 200:
          if (res.data && res.data.success === false && res.data.message === '操作失败，无效的CsrfToken') {
            if (timer) clearTimeout(timer);
            timer = setTimeout(function () {
              return store.dispatch('globalStore/_UpdateUserSesssion');
            }, 200);
          }

          return res;
      }
    }
  } catch (e) {
    return Promise.reject(e);
  }
}

export default {
  request: request,
  responce: responce
};